<template>
  <button
    type="button"
    data-testid="TeacherTimerButton-toggle"
    class="teacher-tool-btn"
    :class="{ selected: timerStore.open }"
    @click="toggle"
  >
    <v-icon class="teacher-tool-icon">fa-light fa-alarm-clock</v-icon>
    <span class="teacher-tool-label">Laiks</span>
  </button>
</template>

<script lang="ts">
import { useAnnotationStore } from "~/stores/annotationStore"
import { useStickyBoardStore } from "~/stores/stickyBoardStore"
import { useStudentGroupsStore } from "~/stores/studentGroupsStore"
import { useStudentWheelStore } from "~/stores/studentWheelStore"
import { useTeacherTimerStore } from "~/stores/teacherTimerStore"

export default {
  setup() {
    const annotationStore = useAnnotationStore()
    const stickyBoardStore = useStickyBoardStore()
    const studentGroupsStore = useStudentGroupsStore()
    const studentWheelStore = useStudentWheelStore()
    const timerStore = useTeacherTimerStore()
    return { annotationStore, stickyBoardStore, studentGroupsStore, studentWheelStore, timerStore }
  },

  methods: {
    toggle() {
      if (this.timerStore.open) {
        this.timerStore.closeTimer()
        return
      }

      if (this.annotationStore.annotationMode && this.annotationStore.isGlobal) {
        this.annotationStore.toggleAnnotationMode()
      }
      this.studentWheelStore.setModalOpen(false)
      this.studentGroupsStore.setModalOpen(false)
      this.stickyBoardStore.setOpen(false)
      this.timerStore.openTimer()
    },
  },
}
</script>
